























import { FileApi } from "../../api/FileApi";

export default {
    name: "PhotoUploader",
    props: {
        multiple: Boolean,
        maxDim: {
            type: Number,
            default: 800,
        },
        quality: {
            type: Number,
            default: 0.8,
        },
        capture: Boolean,
        label: {
            type: String,
            default: "📷 Ajouter une photo",
        },
    },
    data() {
        return {
            FileApi: new FileApi(),
            uploading: false,
        };
    },
    methods: {
        pickFiles: function () {
            if (this.$refs.input) {
                this.$refs.input.click();
            }
        },
        handleFiles: function (event) {
            let self = this;
            let files = event.target.files ? Array.prototype.slice.call(event.target.files) : [];
            if (!files.length) {
                return;
            }

            self.uploading = true;
            self.$emit("start-upload");

            let chain = Promise.resolve();
            files.forEach(function (file) {
                chain = chain.then(function () {
                    return self.uploadOne(file);
                });
            });

            chain
                .then(function () {
                    self.uploading = false;
                    self.$emit("end-upload");
                    event.target.value = "";
                })
                .catch(function (error) {
                    self.uploading = false;
                    self.$emit("end-upload");
                    self.$emit(
                        "error",
                        "Impossible d'envoyer la photo. Veuillez réessayer."
                    );
                    // eslint-disable-next-line no-console
                    console.error(error);
                    event.target.value = "";
                });
        },
        uploadOne: function (file) {
            let self = this;
            return self
                .compressImage(file, self.maxDim, self.quality)
                .then(function (dataUrl) {
                    return self.dataUrlToFile(dataUrl);
                })
                .then(function (compressed) {
                    return self.FileApi.createPhoto(compressed);
                })
                .then(function (photo) {
                    self.$emit("photo-uploaded", photo);
                    return photo;
                });
        },
        /**
         * Réduit l'image à `maxDim` px sur son plus grand côté et la
         * ré-encode en JPEG. Retourne une data-URL.
         */
        compressImage: function (
            file,
            maxDim: number,
            quality: number
        ): Promise<string> {
            return new Promise(function (resolve, reject) {
                let reader = new FileReader();
                reader.onload = function (ev: any) {
                    let img = new Image();
                    img.onload = function () {
                        let w = img.width;
                        let h = img.height;
                        if (w > maxDim || h > maxDim) {
                            if (w > h) {
                                h = (h * maxDim) / w;
                                w = maxDim;
                            } else {
                                w = (w * maxDim) / h;
                                h = maxDim;
                            }
                        }
                        let canvas = document.createElement("canvas");
                        canvas.width = w;
                        canvas.height = h;
                        canvas.getContext("2d").drawImage(img, 0, 0, w, h);
                        resolve(canvas.toDataURL("image/jpeg", quality));
                    };
                    img.onerror = reject;
                    img.src = ev.target.result;
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        dataUrlToFile: function (dataUrl: string): Promise<File> {
            return fetch(dataUrl)
                .then(function (res) {
                    return res.blob();
                })
                .then(function (blob) {
                    return new File([blob], "photo.jpg", {
                        type: "image/jpeg",
                    });
                });
        },
    },
};
